var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-file-picker"},[_c('el-button',{staticStyle:{"margin-bottom":"8px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.handleSelectFile}},[_vm._v(" 选择SVG文件 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }